import { createSlice } from '@reduxjs/toolkit'

export const diseaseDataSlice = createSlice({
  name: 'diseaseData',
  initialState: {
    value: '',
  },
  reducers: {
    handleDiseaseData: (state, action) => {
      state.value = action.payload
    },
  },
})

export const diseaseDataReducer = diseaseDataSlice.reducer
